<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/dashboard">
        <md-icon>visibility</md-icon>
        <p>Dashboard</p>
      </sidebar-link>

      <!-- -----------post Request ---------------------- -->

      <div v-on:click="isHidden = !isHidden" style="margin-top: 5px;margin-bottom: 5px;">
        <sidebar-link to="/post-riquest">
          <md-icon>assignment</md-icon>
          <p>Post Request</p>
          <!-- <md-icon class="arrorr">keyboard_arrow_down</md-icon> -->
        </sidebar-link>
      </div>
      <div v-if="isHidden" class="new-padding">
        <sidebar-link to="/post-riquest/new">
          <md-icon>note_add</md-icon>
          <p>New Post Request</p>
        </sidebar-link>
        <sidebar-link to="/post-riquest/accepted">
          <md-icon>assignment_turned_in</md-icon>
          <p>Accepted Post Request</p>
        </sidebar-link>
        <sidebar-link to="/post-riquest/rejected">
          <md-icon>assignment_late</md-icon>
          <p>Rejected Post Request</p>
        </sidebar-link>
      </div>

      <!-- -----------want this Request ---------------------- -->

      <div v-on:click="isHiddenWant = !isHiddenWant" style="margin-top: 5px;margin-bottom: 5px;">
        <sidebar-link to="/want-riquest">
          <md-icon>chrome_reader_mode</md-icon>
          <p>Want This Request</p>
          <!-- <md-icon class="arrorr">keyboard_arrow_down</md-icon> -->
        </sidebar-link>
      </div>
      <div v-if="isHiddenWant" class="new-padding">
        <sidebar-link to="/want-riquest/new">
          <md-icon>note_add</md-icon>
          <p>New Want Request</p>
        </sidebar-link>
        <sidebar-link to="/want-riquest/accepted">
          <md-icon>assignment_turned_in</md-icon>
          <p>Accepted Want Request</p>
        </sidebar-link>
        <sidebar-link to="/want-riquest/rejected">
          <md-icon>assignment_late</md-icon>
          <p>Rejected Want Request</p>
        </sidebar-link>
      </div>
      <!-- ----------- post pre order Request ---------------------- -->
      <div v-on:click="isHidden2 = !isHidden2" style="margin-top: 5px;">
        <sidebar-link to="/pre-order-request">
          <md-icon>content_paste</md-icon>
          <p>Pre-order Request</p>
          <!-- <md-icon class="arrorr">keyboard_arrow_down</md-icon> -->
        </sidebar-link>
      </div>
      <div v-if="isHidden2" class="new-padding">
        <sidebar-link to="/pre-order-request/new">
          <md-icon>note_add</md-icon>
          <p>New Pre-Order Request</p>
        </sidebar-link>
        <sidebar-link to="/pre-order-request/accepted">
          <md-icon>assignment_turned_in</md-icon>
          <p>Accepted Pre-Order Request</p>
        </sidebar-link>
        <sidebar-link to="/pre-order-request/rejected">
          <md-icon>assignment_late</md-icon>
          <p>Rejected Pre-Order Request</p>
        </sidebar-link>
      </div>

      <sidebar-link to="/icons">
        <md-icon>assignment_ind</md-icon>
        <p>Customers Reviews</p>
      </sidebar-link>

      <sidebar-link to="/icons">
        <md-icon>monetization_on</md-icon>
        <p>Payment Reviews</p>
      </sidebar-link>

      <sidebar-link to="/icons">
        <md-icon>print</md-icon>
        <p>Reports</p>
      </sidebar-link>
      <sidebar-link to="/icons">
        <md-icon>supervised_user_circle</md-icon>
        <p>Account Manage</p>
      </sidebar-link>
      <sidebar-link to="/icons">
        <md-icon>notifications</md-icon>
        <p>Notifications</p>
      </sidebar-link>
      <sidebar-link to="/icons">
        <md-icon>settings_applications</md-icon>
        <p>Setting</p>
      </sidebar-link>

      <!-- <sidebar-link to="/typography">
        <md-icon>library_books</md-icon>
        <p>Typography</p>
      </sidebar-link>
      <sidebar-link to="/icons">
        <md-icon>bubble_chart</md-icon>
        <p>Icons</p>
      </sidebar-link>
      <sidebar-link to="/maps">
        <md-icon>location_on</md-icon>
        <p>Maps</p>
      </sidebar-link>
      <sidebar-link to="/notifications">
        <md-icon>notifications</md-icon>
        <p>Notifications</p>
      </sidebar-link>-->
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content></dashboard-content>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";

export default {
  data: () => ({
    isHidden: false,
    isHiddenWant: false,
    isHidden2: false
  }),
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu
  }
};
</script>
